module.exports = __webpack_public_path__ + "img/user.ab4f3137.png";